// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__anb0E","empty":"ModalGraph_empty__1brbj"};